export const Separator = () => {
  return (
    <div className="h-px bg-gradient-to-r from-transparent via-border to-transparent" />
  );
};
